import React, { useEffect, useState } from "react";
import { useCallback } from "react";
import { TOptionType } from "../../../types/CustomSelect";
import Multiselect from "multiselect-react-dropdown";
import CustomArrow from "../../../utils/CustomStyleComponent/ArrowComponent";
import CustomCrossButton from "../../../utils/CustomStyleComponent/CrossButtonComponent";
import { toast } from "react-toastify";
import { TBrandFilterProps } from "../../../types/Filters/Brand";
// import { getCategory } from "../../../generatedRequest/category";
import { getAllBrand} from "../../../generatedRequest/accessory";
import CustomTooltip from "../../../utils/CustomStyleComponent/TooltipComponent";
import { getAllBrandProduct } from "../../../generatedRequest/product";

const BrandFilter = ({ onBrandFilterChange, currentBrandFilter, isAccesory }: TBrandFilterProps) => {

  type BrandType = { id: string | number; brandName: string; [key: string]: any };
  const [allBrand, setAllBrand] = useState<BrandType[]>([])

  // console.log(currentBrandFilter, "currentBrandFilter")
  
  const style = {
    multiSelectContainer: {
      minheight: "44px",

      border: "1px solid var(--bs-gray-100)",

      // styles for the multiselect container
    },
    searchBox: {
      minheight: "44px",
      fontWeight: "500",
      minwidth: "40px",
      maxwidth: "40px",
      height: "44px",
      display: "flex",
      alignItems: "center",
      width: "350px",

      // styles for the search wrapper
    },
    chips: {
      // To change css chips(Selected options)
      marginBottom: "0",
    },
  };

  useEffect(() => {
    const fn = async () => {
      try {

        let response 
        
       if(isAccesory){
        response = await getAllBrand();
       }
       else{
        response = await getAllBrandProduct();
       }
        console.log(response, "response brand")
        if (response.status) {
          setAllBrand(response.data.data);
        } else {
          toast.error("Something went wrong");
        }
      } catch (error) {
        toast.error("Network Error");
      } finally {
      }
    };
    fn();
  }, []);

  const handleBrandFilter = useCallback(
    (data: any) => {
      onBrandFilterChange(data)
    },
    []
  );

  // Function to get selected values based on currentBrandFilter
  const getSelectedValues = () => {
    if (currentBrandFilter) {
      // Handle if currentBrandFilter is a string
      if (typeof currentBrandFilter === 'string') {
        const brandNames = (currentBrandFilter as string).split(',').map(name => name.trim());
        return allBrand.filter(brand => 
          brandNames.includes(brand.brandName)
        );
      }
      // Handle if currentBrandFilter is an array
      else if (Array.isArray(currentBrandFilter) && currentBrandFilter.length > 0) {
        return allBrand.filter(brand => 
          currentBrandFilter.some(filterBrand => 
            brand.brandName === filterBrand || brand.id === filterBrand
          )
        );
      }
      // Handle if currentBrandFilter is an object
      else if (typeof currentBrandFilter === 'object' && !Array.isArray(currentBrandFilter)) {
        // Assuming it might have brandName or similar property
        // Ensure currentBrandFilter is cast to BrandType for property access
        const filterBrand = currentBrandFilter as unknown as BrandType;
        return allBrand.filter(brand => 
          brand.brandName === filterBrand.brandName || 
          brand.id === filterBrand.id
        );
      }
    }
    return [];
  };

  return (
    <Multiselect
      options={allBrand}
      displayValue="brandName"
      placeholder="Select Brand"
      hidePlaceholder={true}
      selectionLimit={3}
      style={style}
      showArrow={true}
      customArrow={<CustomArrow />}
      customCloseIcon={<CustomCrossButton />}
      avoidHighlightFirstOption={true}
      showCheckbox={true}
      onSelect={handleBrandFilter}
      onRemove={handleBrandFilter}
      selectedValues={getSelectedValues()}
      selectedValueDecorator={(value: string, option: any) => {
        return (
          <CustomTooltip value={value} truncated={true} option={option}/>
        );
      }}
    />
  );
};

export default React.memo(BrandFilter);
